import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["button", "input"]

  connect() {
    // Stop loading controller if no button on turbo re render
    if (!this.hasButtonTarget) {
      return
    }

    // Check if upgrade is required (button is disabled)
    this.upgradeRequired = this.buttonTarget.hasAttribute("disabled") ||
                           this.buttonTarget.disabled

    const isEnabled = this.inputTarget.value === "true"
    this.buttonTarget.classList.toggle("active", isEnabled && !this.upgradeRequired)

    // Ensure disabled state is maintained
    if (this.upgradeRequired) {
      this.buttonTarget.disabled = true
      this.buttonTarget.style.cursor = "not-allowed"
      this.buttonTarget.style.opacity = "0.7"
      this.inputTarget.value = "false"
    }

    this.updateTooltip()
  }

  toggle() {
    // Don't toggle if button is disabled or upgrade required
    if (this.buttonTarget.disabled || this.upgradeRequired) return

    const isEnabled = this.inputTarget.value === "true"
    this.inputTarget.value = (!isEnabled).toString()

    // Dispatch change event for listeners
    this.inputTarget.dispatchEvent(new Event("change"))

    this.buttonTarget.classList.toggle("active", !isEnabled)

    this.updateTooltip()
  }

  updateTooltip() {
    $(this.buttonTarget).tooltip('dispose').tooltip()
  }
}
